import { datadogRum } from '@datadog/browser-rum'
import { formatNameFromPerson } from '@/libs/format/format'
import { LlmDatadogLogEvent, LlmDatadogLoggingDetails } from './types'

/**
 *
 * @param event
 * @param details
 */
export function logLlmEventToRum(
  event: LlmDatadogLogEvent,
  details: LlmDatadogLoggingDetails
) {
  try {
    datadogRum.addAction(event, {
      ...details,
      route: String(details.route.name),
      person: details.person ? formatNameFromPerson(details.person) : '',
    })
  } catch (err) {
    console.error('Failed to log LLM event to Datadog', err)
  }
}
